<template>
  <div class="contact">
    <h2 class="title">contact.</h2>
    <div class="contact-main wow slideInUp animated">
      <p>Let's get connected.<br>Open to collaboration, mentorship, and work opportunities.</p>
      <form action="https://formspree.io/cindy_chea@hotmail.com" method="POST" >
        <!-- <label for="name">Name</label> -->
        <input placeholder="Name" type="text" name="name" id="name">
        <!-- <label for="email">Email</label> -->
        <input placeholder="Email" type="email" name="email" id="email">
        <!-- <label for="message">Message</label> -->
        <textarea placeholder="Message" rows="5" name="message" id="message"></textarea>
        <input type="submit" name="submit" id="submit" placeholder="Submit">
      </form>
      <div class="contact-icons">
          <a href="https://www.linkedin.com/in/cindy-chea/"><fa :icon="['fab', 'linkedin']" /></a>
          <a href="https://github.com/cindychea"><fa :icon="['fab', 'github']" /></a>
          <a href="mailto:cindy_chea@hotmail.com"><fa icon="envelope" /></a>
      </div>
    </div>
    <p class="copyright">© Cindy Chea 2019</p>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'contact',
  components: {
    HelloWorld
  }
}
</script>

<style lang="scss">
.contact {
  min-height: 100vh;
  width: 100%;
  // overflow: scroll;
  background-color: #242B38;
  .title {
    // font-family: 'Montserrat', sans-serif;
    // font-size: 4em;
    // text-align: left;
    // margin: 1.5em;
    color: #FFC7C4;
  }
  .contact-main {
    font-family: 'Raleway', sans-serif;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #242B38;
    p {
      font-size: 2em;
      color: #e63946;
      margin: 1em auto;
    }
    form {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      color: #FFC7C4;
      line-height: 200%;
      label {
        font-size: 1.2em;
      }
      input, textarea {
        border-radius: 5px;
        margin: 8px 0;
        box-shadow: none;
        border: none;
        padding: 10px;
        width: 250px;
        background-color: rgba(#fff, 0.2);
        color: #fff;

      }
      #submit {
        margin-top: 20px;
        border: 1px solid #FFC7C4;
        color: #FFC7C4;
        background-color: #242B38;
        font-weight: bold;
        width: auto;
        margin: 12px auto;
        padding: 12px;
      }
      #submit:hover {
        color: #242B38;
        background-color: #FFC7C4;
      }
    }
  }
  .contact-icons {
    margin-top: 2em;
    a {
      color: #fff;
      text-decoration: none;
      padding: 15px;
      svg {
      font-size: 50px;
      }
    }
    a:hover {
      color: #e93646;
    }
  }
  .copyright {
    margin: 0 auto;
    color: #9c5f7c;
    font-family: 'Montserrat', sans-serif;
    padding-top: 40px;
  }
}
::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #fff;
  opacity: 1; /* Firefox */
}

@media screen and (min-width: 320px) {

}

@media screen and (min-width: 768px) {

}

@media screen and (min-width: 1024px) {

}

@media screen and (min-width: 1920px) {

}
</style>